import Breadcrumbs, { BreadcrumbsProps } from './Breadcrumbs';

export default Breadcrumbs;
export type {
  BreadcrumbsProps,
};
